<template>
    <div>
        <form class="myForm mt-5">
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Descrição:<span class='text-danger'> *</span></label>
                <div class="col-sm-5">
                    <input type="text" class="form-control" v-model="desc" required>
                </div>
            </div>
        </form>

        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2" :disabled="!desc != ''" @click="salvar">Salvar</button>
        </div>
    </div>
</template>

<script>
    import MenuInterno from '../menu-interno/MenuInterno.vue'

    export default {
        name: 'ServicosCadastro',
        components: {
            MenuInterno
        },
        data() {
            return {
                desc: ''
            }
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            salvar() {
                API.enviarRequisicao('post', '/api/sist-obras/tipo-servicos', {
                    c02_descr: this.desc
                }).then(response => {
                        this.$swal('Parabéns!', 'Dados salvos com sucesso.', 'success')
                            .then(
                                function () {
                                    history.go(0);
                                }
                            )
                    })
                    .catch(function (error) {
                        this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'error')
                    })
            }
        },
    }
</script>

<style scoped>

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

    .myForm {
        padding: 20px;
        border: 1px solid #ccc;
        width: 100%;
        height: auto;
        margin-bottom: 10px;
    }
</style>
